import ActionType from 'constants/actionType';
import learnerImportSuccessNotification from 'component/raNotification/learnersImportSuccessNotification';
import learnerImportErrorNotification from 'component/raNotification/learnersImportErrorNotification';

export const withLearnerImportNotifications =
  
  /**
   * @param {typeof NotificationStore} NotificationStoreConstructor
   */
  (NotificationStoreConstructor) => {
    NotificationStoreConstructor.LEARNERS_IMPORT_SUCCESS_NOTIFICATION = 'LEARNERS_IMPORT_SUCCESS_NOTIFICATION';
    NotificationStoreConstructor.LEARNERS_IMPORT_ERROR_NOTIFICATION = 'LEARNERS_IMPORT_ERROR_NOTIFICATION';
    
    const notificationToActionTypeMap = NotificationStoreConstructor.prototype._notificationToActionTypeMap;
    notificationToActionTypeMap[NotificationStoreConstructor.LEARNERS_IMPORT_SUCCESS_NOTIFICATION] =
      [ActionType.LEARNERS_IMPORT_SUCCESS];
    notificationToActionTypeMap[NotificationStoreConstructor.LEARNERS_IMPORT_ERROR_NOTIFICATION] =
      [ActionType.LEARNERS_IMPORT_ERROR];
    
    Object.defineProperty(NotificationStoreConstructor.prototype, '_notificationToActionTypeMap', {
      get() {
        return { ...notificationToActionTypeMap };
      },
      configurable: true
    });
  
    Object.defineProperty(NotificationStoreConstructor.prototype, 'notificationData', {
      get() {
        return {
          ...this._notificationData,
          [NotificationStoreConstructor.LEARNERS_IMPORT_ERROR_NOTIFICATION]: learnerImportErrorNotification,
          [NotificationStoreConstructor.LEARNERS_IMPORT_SUCCESS_NOTIFICATION]: learnerImportSuccessNotification
        };
      }
    });
  };
